//@flow
import React from 'react';
import { getRowCell } from './helpers';
import { Typography } from '@hiver/hiver-ui-kit';

const RowCells = ({ data, columns, classes }) => {
    return columns.map((col, idx) => {
        let className;
        if (col.align === 'center')
            className = `h-tcell ${classes.cell} ${classes.cellCenter} h-h3`;
        else if (col.align === 'right')
            className = `h-tcell ${classes.cell} ${classes.cellEnd} h-h3`;
        else
            className  = `h-tcell ${classes.cell} h-h3`;
        const fieldData = getRowCell(data, col.accessor, col.cell);
        const disabledClass = (data.disableSelect && !data.isSourceUserForSm && typeof fieldData == 'string') ? 'h-disabled' : '';

        return <Cell key={idx}
            idx={idx}
            data={fieldData} 
            disabled={data.disabled}
            className={`${className} ${disabledClass}`}
            onClick={col.cellAction} 
            classes={classes}
        />        
    })
}

const Cell = ({ className, onClick, data, classes, disabled, idx }) => {
    if (disabled)
        className = `${className} ${classes.disabledCell}`;
    const title = typeof data !== 'object' ? data : '';
    return <div title={title} className={className} key={`user-table-row-item-${idx}`}>
        <Typography variant="body2" noWrap>
            { data }
        </Typography>
    </div>
}


export default RowCells